import React, { useEffect, useRef, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import { CopyIcon, EditIcon, TrashIcon, UpdateIcon, ViewIcon } from "../utils/Icons";
import { bm_date, buildFileFromChunks, cycleArray, drawQty, getClerkName, getEnumLabel, getSaved, kbdEvent, requestClerkCode, requestPrompt, showConfirm, showInfo, writeFile, writeXLSX } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Row from "../ui/Row";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Nav from "../ui/Nav";
import Divider from "../ui/Divider";
import ReportsCustomEdit from "./ReportsCustomEdit";
import { ROUTES } from "../utils/Routes";
import ReportsCustomGroups from "./ReportsCustomGroups";
import Tags from "../ui/Tags";
import ReportFilter from "./ReportFilter";
import ImportReports from "../popups/ImportReports";
import { ENUMS } from "../utils/Enums";
import Spin from "../ui/Spin";
import { drawPicker } from "../popovers/Picker";
import { getDefaultColumns } from "./ReportColumns";
import dayjs from "dayjs";
import DateField from "../ui/DateField";
import TimeField from "../ui/TimeField";
import InventoryController from "../controllers/InventoryController";
import { createScreen } from "../hooks/createScreen";
import DateInput from "../ui/DateInput";
import { getInventoryReportTemplate } from "../data_structures/ReportTemplates";
import Cookies from "js-cookie";
import ToolTip from "../ui/ToolTip";
import Float from "../ui/Float";
import Button from "../ui/Button";
import ReportsPrintExport from "./ReportsPrintExport";
import { createModal } from "../hooks/createModal";
export default function ReportsCustomInventory(props) {

    const { controller = "", setController = () => { }, route = "", signal = {} } = props;
    const [loading, setLoading] = useState(false);
    const [loadingPrompt, setLoadingPrompt] = useState(false);
    const [filters, setFilters] = useState({ limit: 40, sort: "updated", group: "", filter: "inventory" }); // name, clerk, updated
    const [align, setAlign] = useState("start");
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [groups, setGroups] = useState([])
    const [edit, setE] = useState(false);
    const [state, setState] = useState({ view: "reports" })
    const row_key = "report_id";
    const buffer = 20;
    const [blank, setBlank] = useState(false);

    const inventoryRef = useRef();

    const [initIndex, setInitIndex] = useState("");
    const setEdit = (e, init_index = "") => {
        setInitIndex(init_index);

        if (!e) {
            // Unsetting...
            setE(e)
            return;
        }

        // new...
        if (!e?.report_id) {
            setE(e);
            return;
        }

        setLoading(true);
        pubCall("report.getReport", { report_id: e?.report_id || "" }, (_s, _r) => {
            if (_s) {
                setE(_r)
            } else {
                showError(_r);
            }
            setLoading(false);
        })

    }

    const switchView = (_view) => {

        switch (_view) {
            case "reports":
                window.bm_state.value = route;
                break;
            case "groups":
                window.bm_state.value = ROUTES.REPORTS.CUSTOM_INVENTORY_GROUPS
                break;
        }

        setState({ ...state, "view": _view });
    }


    function updateRow(_row) {
        let _d = [...data];
        let _f = _d.findIndex(item => item?.[row_key] === _row?.[row_key]);
        if (_f > -1) {
            _d[_f] = _row;
            setData(_d);
        }
    }

    const updateReport = (async = true, view = false) => {

        if (!selected?.[row_key]) return;
        setLoading(true);
        setLoadingPrompt(true)
        pubCall("report.updateReport", { report_id: selected?.[row_key] }, (_s, _r) => {

            let _cookie = Cookies.get("reports_report_stock");
            if (_cookie) {
                try {
                    _cookie = JSON.parse(_cookie);
                } catch {
                    _cookie = null;
                }
                if (_cookie?.report_id === selected?.[row_key]) {
                    // matches, reset
                    Cookies.set("reports_report_stock", "");
                }
            }


            setLoadingPrompt(false)
            setLoading(false);

            if (_s) {
                updateRow(_r);
                setSelected(_r);

                if (edit) {
                    setE(_r);
                }

                const canOpenView =
                    window.bm_state.value === route ||
                    window.bm_state.value === ROUTES.REPORTS.CUSTOM_EDIT;

                if (view && canOpenView) {
                    viewReport(
                        async,
                        Cookies.get("report_column_view") !== "",
                        _r
                    );

                    return;
                }

                if (async && window.bm_state.value !== route) {
                    showMessage(
                        <>
                            Report: <strong><em>{_r.name}</em></strong>
                            <br />
                            has been completed in the background.
                        </>,
                        10000,
                        "pinned"
                    );
                } else {
                    showMessage("Report completed.");
                }
            } else {
                showError(_r);
            }

        })
    }


    const copyReport = () => {
        if (!selected?.[row_key]) return;
        createReport({ ...selected, "name": "Copy of " + selected.name, id: "" });
    }



    const showPrintExport = () => {

        if (!selected?.[row_key]) {
            showError({ error: "No report selected" })
            return;
        }

        const return_route = window.bm_state.value;
        window.bm_state.value = ROUTES.REPORTS.PRINT_EXPORT;

        createModal({
            offset: [0, 0],
            mask_close: true,
            align: "center",
            title: "Print / Export",
            component: <ReportsPrintExport exportReport={exportReport} controller={controller} route={ROUTES.REPORTS.PRINT_EXPORT} />,
            closable: true,
            callback: (e) => {
                if (e === "XLSX") {
                    exportReport(true)
                }
                if (e === "CSV") {
                    exportReport(false)
                }
                window.bm_state.value = return_route;
            },
        });
    }


    const exportReport = (_xlsx = false) => {

        if (!selected?.[row_key]) return;

        let _api = "report.exportReportToCsv"
        let _file_type = ".csv (comma separated values)";
        if (_xlsx) {
            _api = "report.exportReportToXlsx"
            _file_type = ".xlsx (Excel document)";
        }
        setLoading(true)
        setLoadingPrompt(true)
        let _name = selected?.name || "";
        pubCall(_api, { report_id: selected?.[row_key], want_header: true }, (_s, _r) => {
            if (_s) {
                buildFileFromChunks(_r, pubCall, setLoading, () => {
                    if (window.bm_state.value !== route) {
                        showMessage(<>File: <strong><em>{_name}{_file_type}</em></strong><br />has been downloaded in the background.</>, 10000, "pinned")
                    } else {
                        showMessage("File created successfully.")
                    }
                })
            } else {
                showError(_r)
            }
            setLoading(false);
            setLoadingPrompt(false);
        })
    }


    const viewReport = (async = true, expand = (Cookies.get("report_column_view") === "") ? false : true, _selected = selected) => {





        if (!_selected?.[row_key]) {
            showError("Not selected")
            return;
        }
        const _route = window.bm_state.value;
        if (_selected?.cached_row_total === null) {
            updateReport(async, true);
            return;
        }

        if (!_selected.cached_row_total) {

            showInfo({
                controller: controller,
                route: route,
                description: <div style={{ "textAlign": "center" }}>This report has <strong>no results</strong>. <div className="shim" /> Review the parameters and try again.</div>,
                callback: () => { },
                title: "Warning",
                width: 300,
                type: "warning"
            });


            return;
        }

        window.bm_state.value = ROUTES.INVENTORY.INVENTORY;

        createScreen({
            is_modal: true,
            target: inventoryRef.current,
            signal,
            component: (
                <InventoryController
                    showPrintExport={showPrintExport}
                    setController={setController}
                    controller={controller}
                    is_modal={_selected}
                    expand={expand}
                    route={ROUTES.INVENTORY.INVENTORY}
                />
            ),
            closable: false,
            title: "Select Customer",
            callback: () => {
                if (
                    window.bm_state.value === ROUTES.INVENTORY.INVENTORY
                ) {
                    window.bm_state.value = _route;
                }
            }
        });

    }

    const createReport = (_report = false, _template = {}) => {


        let _new_report = { ..._template };

        // New
        if (!_report) {
            setEdit(_new_report)
        } else {
            // Copy
            _new_report = _report;
            _new_report.report_id = "";
            pubCall("report.addReport", { new_report: _new_report }, (_s, _r) => {
                setLoading(false)
                if (_s) {
                    setEdit(_r);
                    setSelected(_r);
                } else {
                    showError(_r);
                }
            })
        }

    }


    const openImportReport = () => {
        const origin = window.bm_state.value;
        window.bm_state.value = ROUTES.REPORTS.IMPORT_REPORTS;
        createModal({
            component: <ImportReports controller={controller} route={ROUTES.REPORTS.IMPORT_REPORTS} />, closable: true, title: "Import Bookmanager Report", callback: (e) => {

                if (e) {
                    const report_num = e;

                    const columns = [
                        {
                            "position": 0,
                            "column_id": "",
                            "display_name": "ISBN",
                            "size": 132,
                            "type": 11
                        },
                        {
                            "position": 1,
                            "column_id": "",
                            "display_name": "aOH",
                            "size": 48,
                            "type": 2
                        },
                        {
                            "position": 2,
                            "column_id": "",
                            "display_name": "aOO",
                            "size": 48,
                            "type": 3
                        },
                        {
                            "position": 3,
                            "column_id": "",
                            "display_name": "Price",
                            "size": 76,
                            "type": 25
                        },
                        {
                            "position": 4,
                            "column_id": "",
                            "display_name": "Title",
                            "size": 384,
                            "type": 42
                        },
                        {
                            "position": 5,
                            "column_id": "",
                            "display_name": "Author",
                            "size": 244,
                            "type": 4
                        },
                        {
                            "position": 6,
                            "column_id": "",
                            "display_name": "Supl",
                            "size": 48,
                            "type": 41
                        },
                        {
                            "position": 7,
                            "column_id": "",
                            "display_name": "Class (Main)",
                            "size": 169,
                            "type": 7
                        },
                        {
                            "position": 8,
                            "column_id": "",
                            "display_name": "D",
                            "size": 20,
                            "type": 36
                        },
                        {
                            "position": 9,
                            "column_id": "",
                            "display_name": "P",
                            "size": 20,
                            "type": 28
                        }
                    ];

                    pubCall("report.convertBookmanagerReport", { report_num_digits: report_num, columns: columns }, (_s, _r) => {
                        if (_s) {
                            showMessage("Report imported successfully.");
                            fetch();
                        } else {
                            showError(_r);
                        }
                        window.bm_state.value = origin;
                    });

                } else {
                    window.bm_state.value = origin;
                }
            }
        })
    }


    const createFromTemplate = (_grp = "") => {


        drawPicker({
            controller: controller,
            title: "Create from template", closeable: true, height: 300, ref: null, route: route, callback: (e) => {
                if (e) {
                    createReport(false, getInventoryReportTemplate(e, filters.group));
                }
            }, offset: [0, 10],
            options: ENUMS.REPORT_TEMPLATES
        })

    }

    const drawSearch = () => {
        requestPrompt({
            route: route, title: "Search", inputProps: { style: { "textAlign": "left" } }, callback: (_s) => {
                setFilters({ ...filters, "search_term": _s });
            }
        })

    }

    const nav = [
        { key: KBD.B, text: "BM Import", action: () => { openImportReport() }},
        { key: KBD.C, text: "Copy", action: () => { (selected?.[row_key]) ? copyReport() : showError({ error: "No report selected" }) } },
        { key: KBD.D, text: "Del", action: () => { removeReport() } },
        { key: KBD.E, text: "Edt", action: () => { (selected?.[row_key]) ? setEdit(selected) : showError({ error: "No report selected" }) } },
        { text: "Filt" },
        { key: KBD.I, text: "Indx", action: () => { drawIndex() } },        
        { key: KBD.N, text: "New", action: () => createFromTemplate() },
        { key: KBD.P, text: "Print / Export", action: () => showPrintExport() },
        { key: KBD.S, text: "Srch", action: () => { drawSearch() } },
        { key: KBD.U, text: "Update", action: () => (selected?.[row_key]) ? updateReport(true, true) : showError({ error: "No report selected" }) },
        { key: KBD.V, text: "View", action: () => (selected?.[row_key]) ? viewReport() : showError({ error: "No report selected" }) },
        // { key: KBD.X, text: "Xlsx", action: () => (selected?.[row_key]) ? showPrintExport() : showError({ error: "No report selected" }) },
    ]


    const group_nav = [
        { key: KBD.N, text: "New", action: () => createFromTemplate() },
    ]

    const columns = [
        {
            key: "clerk", colSort: { current: filters.sort, callback: (e) => { setFilters({ ...filters, "sort": "clerk" }); } }, align: "left", title: <>CL</>, width: 40, grow: false, render: (e) => {
                return (<ToolTip text={getClerkName(e)}>{e}</ToolTip>)
            }
        },
        {
            key: "group", align: "left", title: <>Group</>, width: 150, grow: false
        },
        {
            key: "date_changed", colSort: { current: (filters.sort === "updated") ? "date_changed" : "", callback: (e) => { setFilters({ ...filters, "sort": "updated" }); } }, align: "left", title: <>Updated</>, width: 100, grow: false, render: (e) => {
                return <span style={{ "fontFamily": "var(--font-mono)" }}>{bm_date(e)}</span>
            }
        },
        { key: "name", colSort: { current: filters.sort, callback: (e) => { setFilters({ ...filters, "sort": "name" }); } }, align: "left", title: <>Name</>, width: 170, grow: true, shrink: true },
        {
            key: "cached_row_total", align: "left", title: <>Items</>, width: 110, grow: false, render: (e) => {
                return (e || e === 0) ? <span style={{ "color": "var(--text-green)" }}>{e}</span> : <span style={{ "color": "var(--text-red)" }}>Not run</span>
            }
        },
        {
            key: "type", align: "left", title: <>Scope</>, width: 170, grow: false, render: (e) => {
                return getEnumLabel(ENUMS.REPORTS_SCOPE, e);
            }
        },
        {
            key: "filters", align: "left", title: <>Filters #</>, width: 70, grow: false, render: (e) => {
                return drawQty(e.filter(item => item.type > -1).length);
            }
        },

        {
            key: "actions", align: "left", title: <>Actions</>, width: 120, grow: false, render: (e, f) => {
                return (
                    <Space size={10}>

                        <ToolTip text="Edit Report"><a onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setSelected(f);
                            setEdit(f);
                        }} style={{ "color": "var(--input-edit-bg)" }}><EditIcon /></a></ToolTip>
                        <ToolTip text="View Report"><a onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setSelected(f);
                            viewReport(false, Cookies.get("report_column_view") === "", f);
                        }}><ViewIcon /></a></ToolTip>
                        <ToolTip text="Update Report"><a onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setSelected(f);
                            updateReport(false, true);
                        }}><UpdateIcon /></a></ToolTip>
                        <ToolTip text="Delete Report"><a onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            setSelected(f);
                            removeReport(f);
                        }} style={{ "color": "var(--text-red)" }}><TrashIcon /></a></ToolTip>
                    </Space>
                )
                return drawQty(e.filter(item => item.type > -1).length);
            }
        },
    ]


    const drawReportResultsString = () => {

        if (!selected?.[row_key]) { return; }

        const { order_1 = "", order_2 = "", order_3 = "", cached_row_total } = selected;

        const order = [
            order_1 ? getEnumLabel(ENUMS.REPORTS_INDEX, order_1) : "Enter date",
            order_2 && getEnumLabel(ENUMS.REPORTS_INDEX, order_2),
            order_3 && getEnumLabel(ENUMS.REPORTS_INDEX, order_3)
        ].filter(Boolean);

        return (
            <div>
                Indexed by <span style={{ color: "var(--text-light)" }}>{order.join(", ")}</span>
            </div>
        );
    };


    const removeReport = (_selected = selected) => {
        if (!_selected?.[row_key]) { return; }

        showConfirm({
            controller: controller,
            route: route,
            title: "Delete report?",
            callback: (e) => {
                if (e) {
                    setLoading(true);
                    pubCall("report.removeReport", { report_id: _selected?.[row_key] }, (_s, _r) => {
                        if (_s) {
                            let _f = data.findIndex(item => item?.[row_key] === _selected?.[row_key]);
                            if (data.length > _f + 1) {
                                setSelected(data[_f + 1]);
                            }
                            else if (data.length > 0) {
                                setSelected(data[_f - 1]);
                            }
                            else { setSelected({}) }
                            setData(data.filter(item => item?.[row_key] !== _selected?.[row_key]));
                        } else {
                            showError(_r);
                        }
                        setLoading(false)
                    })

                }
            }
        })

    }

    const drawIndex = () => {

        let _obj = cycleArray(ENUMS.REPORT_SORT_FILTER, "value", filters?.sort);
        setFilters({ ...filters, "sort": _obj.value });
        return;
        drawPicker({
            value: filters.sort, title: "Index", closeable: true, height: 300, ref: null, route: route, close: () => { }, callback: (e) => {
                if (e) {
                    setFilters({ ...filters, "sort": e })
                }
            }, offset: [0, 10],
            options: ENUMS.REPORT_SORT_FILTER
        })
    }


    const drawGetStarted = () => {


        showConfirm({
            controller: controller,
            route,
            defaultYes: true,
            description: <div style={{ "textAlign": "center" }}>
                Create custom inventory reports to explore <br />and better understand your business data.
                <br /> <br />
                Create your first report?</div>,
            title: "Get Started",
            callback: (e) => {
                if (e) {
                    setTimeout(() => {
                          createFromTemplate()
                    }, 50)
                  
                }
            }
        })

    }

    const fetch = (_id = "") => {
        if (loading || edit) { return }
        setLoading(true);
        let _filters = { ...filters }
        if (_id) {
            _filters.report_id = _id;
        }

        let _api = "report.getReportInitial";

        if (_filters?.search_term) {
            _filters.search_term = _filters.search_term.toString();
            _api = "report.searchReports";
            delete _filters.report_id;
        }



        pubCall(_api, _filters, (_s, _r) => {
            if (_s) {

                if (!_r.rows_previous.length && !_r.rows_next.length) {
                      setLoading(false);
                    drawGetStarted()
                    return;
                }

                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, [filters, edit]);


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;


        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        pubCall("report.getReportNext", { ...filters, "limit": 20, [row_key]: data[data.length - 1]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        pubCall("report.getReportPrevious", { ...filters, "limit": 20, [row_key]: data[0]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }



    useEffect(() => {

        let actions = [
            { key: KBD.ESCAPE, action: (e) => { props.switchView("reports") } },
            { key: KBD.ARROW_LEFT, action: (e) => { switchView("groups") } },
            { key: KBD.ARROW_RIGHT, action: (e) => { switchView("reports") } },
            { key: KBD.ENTER, action: (e) => { if (selected?.[row_key]) { setEdit(selected) } } }
        ];

        if (loading) {
            actions = [{ key: KBD.ESCAPE, action: (e) => { props.switchView("reports") } }]
        }

        const cleanup = listen(controller, route, actions.concat(nav), false, [KBD.ENTER]);
        return cleanup;
    }, [selected, loading]);


    const refresh = (_e) => {
        setBlank(true);
        setEdit(false);
        setTimeout(() => {
            setBlank(false);
            setEdit(_e);
        }, 0)
    }





    if (blank) {
        return <></>;
    }

    const drawEscape = () => {

        if (!loadingPrompt) {
            return;
        }

        return (
            <div style={{ "backgroundColor": "#000000", "border": "1px solid var(--border-secondary)", "width": "340px", "padding": "15px" }}>
                <Label style={{ textAlign: "center" }}>
                    <span style={{ "color": "var(--text-light)" }}><strong>Reports and files may take a while to process.</strong></span> <br />
                    <div className="shim" />
                    You can exit now — the report/file will continue generating in the background and be available later. <br /><br />
                    Press <kbd onClick={() => kbdEvent(KBD.ESCAPE)}>Esc</kbd> to continue.
                </Label>
            </div>
        )

    }

    const sales_period_between = selected?.filters?.find(item => item.type === -5);
    const _date_from = (sales_period_between?.value_1) ? sales_period_between?.value_1 : "";
    const _date_from_time = (sales_period_between?.value_1 && sales_period_between?.value_1.includes(" ")) ? sales_period_between?.value_1 : "";
    const _date_to = (sales_period_between?.value_2) ? sales_period_between?.value_2 : "";
    const _date_to_time = (sales_period_between?.value_2 && sales_period_between?.value_2.includes(" ")) ? dayjs(sales_period_between?.value_2).valueOf() : "";


    const invoices_between = selected?.filters?.find(item => item.type === -6);
    const _from = (invoices_between?.value_1) ? invoices_between?.value_1 : "";
    const _to = (invoices_between?.value_2) ? invoices_between?.value_2 : "";


    const sales_types = selected?.filters?.find(item => item.type === -7);
    const sales_types_string = sales_types?.value_1 || "xx";

    const has_selection = (selected?.[row_key]);


    return (


        <div>
            <div ref={inventoryRef}></div>
            {edit &&
                <ReportsCustomEdit controller={controller} initIndex={initIndex} refresh={refresh} loading={loading} updateReport={updateReport} viewReport={viewReport} groups={groups} edit={edit} setEdit={(e) => {
                    setEdit(e)
                    setSelected(e)
                }} signal={signal} route={ROUTES.REPORTS.CUSTOM_EDIT} callback={() => {


                    window.bm_state.value = route
                    setEdit(false)
                }} />
            }
            {(!edit &&
                <Spin async={<>{drawEscape()}</>} loading={loading}>
                    <div className="controller component-layout">
                        <div style={{ display: "flex", gap: "15px", "padding": "0px", "height": "100%" }}>
                            <div onClick={() => switchView("groups")} style={{ width: '200px', flexShrink: "0", }}>
                                <Label style={{ "textAlign": "left" }}>Report Groups</Label>
                                <div className="shim" />
                                <div className={(state.view === "groups") ? "" : "desaturate"}><ReportsCustomGroups controller={controller} group_nav={group_nav} data={data} groups={groups} setGroups={setGroups} group={filters?.group} setGroup={(e) => setFilters({ ...filters, "group": e })} switchView={switchView} escape={() => { props.switchView("reports") }} route={ROUTES.REPORTS.CUSTOM_INVENTORY_GROUPS} /></div>
                            </div>
                            <div onClick={() => switchView("reports")} style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>

                                <div className={(state.view === "reports") ? "" : "desaturate"} style={{ flex: 1 }}>
                                    <Float>
                                        <Label style={{ "textAlign": "left" }}>Group <strong>Sales</strong></Label>
                                        <Label style={{ "textAlign": "left" }}><Button onClick={() => kbdEvent(KBD.N)} type="link"><strong style={{ "textTransform": "none" }}>New Report +</strong></Button></Label>
                                    </Float>
                                    <div className="shim" />
                                    <VirtualTable
                                        controller={controller}
                                        scrollbar={true}
                                        // onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                                        // className={(state.view === "customers") ? "" : "desaturate"}
                                        // onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                                        onRowClick={(item) => setEdit(item)}
                                        next={next}
                                        prev={prev}
                                        // align={align}
                                        row_key={row_key}
                                        current={selected}
                                        data={data}
                                        columns={columns}
                                        width={0}
                                        height={180}
                                        // loading={loading}
                                        offset={480}
                                        route={route}
                                    />
                                    {(has_selection &&
                                        <div className="flex-height">
                                            <div className="shim" /><div className="shim" />
                                            <Label style={{ "textAlign": "left" }}><Space>Report Parameter Preview <div>|</div> {drawReportResultsString()} </Space></Label>
                                            <div className="shim" /><div className="shim" /><div className="shim" />
                                            <div onDoubleClick={() => setEdit(selected, "scope")} >
                                                <Space size={8}>
                                                    <Label>Scope</Label>
                                                    <Input shrink={false} width={200} value={getEnumLabel(ENUMS.REPORTS_SCOPE, selected?.scope_type)} />
                                                    {(selected.scope_type === 2) &&
                                                        <Space size={8}>
                                                            <Label>Date</Label>
                                                            <DateInput shrink={false} width={95} value={_date_from} />
                                                            <TimeField shrink={false} width={50} value={_date_from_time} />
                                                            <Label>to</Label>
                                                            <DateInput shrink={false} width={95} value={_date_to} />
                                                            <TimeField shrink={false} width={50} value={_date_to_time} />
                                                        </Space>
                                                    }
                                                    {(selected.scope_type === 3) &&
                                                        <Space size={8}>
                                                            <Label >Invoice between</Label>
                                                            <Input shrink={false} width={95} value={_from} />
                                                            <Label>to</Label>
                                                            <Input shrink={false} width={90} value={_to} />
                                                        </Space>
                                                    }
                                                    {(selected.scope_type === 2 || selected.scope_type === 3) &&
                                                        <Space size={8}>
                                                            <Label grow width={80}><nobr>Sales Types</nobr></Label>
                                                            <Tags height={24} width={450} readvalue={sales_types_string} items={ENUMS.SALES_TYPES} />
                                                        </Space>
                                                    }
                                                </Space>
                                            </div>
                                            <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                                            <div style={{ display: "flex", flex: 1, gap: 10, width: "100%", "pointerEvents": "none", "height": "100%" }}>
                                                <div onDoubleClick={() => setEdit(selected, "filter_all")} style={{ flex: 1, padding: "0px", boxSizing: "border-box" }}>
                                                    <ReportFilter controller={controller} height={202} data={selected?.filters?.filter(item => item.type > -1 && item.where_type === "AND")} headerClass="dark-green" showColumnHeaders={false} header="All of (Must/All)" small edit={false} />
                                                </div>
                                                <div onDoubleClick={() => setEdit(selected, "filter_one")} style={{ flex: 1, padding: "0px", boxSizing: "border-box" }}>
                                                    <ReportFilter controller={controller} height={202} data={selected?.filters?.filter(item => item.type > -1 && item.where_type === "OR")} headerClass="dark-orange" showColumnHeaders={false} header="One of (Include/Any)" small edit={false} />
                                                </div>
                                                <div onDoubleClick={() => setEdit(selected, "filter_none")} style={{ flex: 1, padding: "0px", boxSizing: "border-box" }}>
                                                    <ReportFilter controller={controller} height={202} data={selected?.filters?.filter(item => item.type > -1 && item.where_type === "NOT")} headerClass="dark-red" showColumnHeaders={false} header="None of (Exclude)" small edit={false} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>

                        <div className="flex-bottom">
                            <div className="shim" />
                            <Divider />
                            <div className="nav-wrapper">
                                <Space style={{ padding: "0px 15px" }}>
                                    {(state.view === "reports" && <Nav nav={nav} />)}
                                    {(state.view === "groups" && <Nav nav={group_nav} />)}
                                </Space>
                            </div>
                        </div>



                    </div>
                </Spin>
            )}
        </div>
    )

}